import { styled } from '@mui/material';
import MuiTabs from '@mui/material/Tabs';
import { globalClasses } from 'core/common/constants/global-classes';

export const TabsStyled = styled(MuiTabs)`
  & ${globalClasses.tabIndicator} {
    display: none;
  }
`;
